var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6,
    rx: 6,
    ry: 6,
    transform: "rotate(-90 6 6)",
    fill: "#01BC62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusGreenIcon);
export default __webpack_public_path__ + "static/media/status_green_icon.9d1f535b89dd905a17aacbe586af5cf2.svg";
export { ForwardRef as ReactComponent };